import { Table } from "@/features/Table";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type M2Position, useM2PositionColumns } from "./columns";
import { type FilterM2PositionsSchema, FilterM2Positions } from "./filter";

export const M2PositionsTable = () => {
  const columns = useM2PositionColumns();
  return (
    <Table<M2Position, FilterM2PositionsSchema>
      label="Positions"
      client={Clients.M2}
      table_name={Tables.M2_POSITIONS}
      columns={columns}
      filter={<FilterM2Positions />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.M2}/${Tables.M2_POSITIONS}/new`,
        },
      ]}
    />
  );
};
